<template>
  <div class="authorize_upgrade" v-if="isShowUpgradeBtn == true">
    <span>{{ $t('authorize_upgrade') }}</span>
    <div class="authorize_btn button ghost" @click="upgradeClick">{{ $t('authorize_btn') }}</div>
  </div>
</template>
<script lang="ts">
const isShowUpgradeBtn = ref(true)
export { isShowUpgradeBtn }
</script>
<script setup lang="ts">
import { ref } from 'vue'
import { isShowUpgrade } from './upgrade.vue'
import { isShowAuthorize } from '../authorize/authorize.vue'

const upgradeClick = () => {
  isShowUpgrade.value = true
  isShowAuthorize.value = false
  isShowUpgradeBtn.value = false
}
</script>

<style scoped lang="less">
.authorize_upgrade {
  position: fixed;
  right: 50px;
  bottom: 40px;
  display: flex;
  align-items: end;

  span {
    color: rgba(#ffffff, 0.8);
    margin-right: 16px;
  }

  .authorize_btn {
    padding: 10px 32px;
    font-weight: 600;
  }
}
</style>
